import { useState, useEffect } from 'react';
import { departmentService } from '../services/departmentService';

export const useDepartments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await departmentService.getActiveDepartments();
      setDepartments(data);
    } catch (err) {
      console.error('Error loading departments:', err);
      setError(err.message);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  const getDepartmentLabel = (departmentCode) => {
    if (!departmentCode) return '';
    const dept = departments.find(d => d.departmentCode === departmentCode);
    return dept ? dept.departmentName : departmentCode;
  };

  const getDepartmentsBySector = (sectorValue) => {
    return departments
      .filter(d => d.sector === sectorValue)
      .sort((a, b) => (a.priority || 999) - (b.priority || 999));
  };

  const getDepartmentOptions = (sectorValue = null) => {
    const depts = sectorValue 
      ? getDepartmentsBySector(sectorValue)
      : departments.sort((a, b) => (a.priority || 999) - (b.priority || 999));
    
    return depts.map(dept => ({
      value: dept.departmentCode,
      label: dept.departmentName,
      sector: dept.sector,
      priority: dept.priority
    }));
  };

  return {
    departments,
    loading,
    error,
    getDepartmentLabel,
    getDepartmentsBySector,
    getDepartmentOptions,
    reload: loadDepartments
  };
};